const GLOBAL_APP_COUNT: string = '2,000';
/**
 * Returns formatted GLOBAL_APP_COUNT (e.g. 2,000+) if appCount param is >= than GLOBAL_APP_COUNT
 */

const globalAppCount = parseInt(GLOBAL_APP_COUNT.replace(',', ''));

const formatTotalCount = (appCount: number) =>
  Number(appCount) >= globalAppCount
    ? `${globalAppCount.toLocaleString()}+`
    : Number(appCount).toLocaleString();

export default formatTotalCount;
